
<template>
  <div style="width: 100%; height: 100%;">
    <div class="container">
      <div class="row">
        <div class="col-12" style="padding-top: 50px;">
          Sorry for your inconveniences.
          <br/>
          The order session has been cancelled due to a problem.
          <br/>
          Please scan the QR code on the table again.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'ErrorView',
  data() {
    return{

    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods:{

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ErrorView.vue